<template>
  <div class="modal fade" id="popup" role="dialog" data-backdrop="static" data-keyboard="false" @click.stop>
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content">
        <div class="popup-content" v-html="popupData.content"></div>
        <div v-if="popupData.noDispSuppression" class="flex flex-content-center gap-10">
          <input type="checkbox" v-model="noDipsOption" id="no-disp-option" class="form-check-input">
          <label for="no-disp-option" class="form-check-label">{{ `本メッセージを${popupData.noDispTerm}日間表示しない` }}</label>
        </div>
        <div class="flex mr-t-10">
          <button type="button" class="btn btn-normal" @click="closePopup()">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    popupData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      noDipsOption: false
    }
  },
  methods: {
    closePopup () {
      this.$emit('close', this.noDipsOption)
    }
  },
  mounted () {
    $('#popup').modal('show')
  },
  beforeDestroy () {
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
.modal-content {
  padding: 20px;
}
.popup-content {
  min-height: 400px;
  max-height: 600px;
}
.form-check-input {
  margin: unset;
}
.form-check-label {
  margin: unset;
  font-weight: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue